import './Container.css';

export function Container({ children, maxWidth = 'default', className = '' }) {
  const containerClass = `container container--${maxWidth} ${className}`.trim();

  return <div className={containerClass}>{children}</div>;
}

export default Container;
